<div class="flex-row-split height100p">
    <p-panel class="flex-item-fixed width500 full-height" header="Optionen">
        <p-splitButton icon="fas fa-tower-broadcast" label="Adapterdefiniton laden ..." [model]="menuItems"
            (onClick)="loadAdapter()"></p-splitButton>
        <app-config-editor-tree #configEditorTree [def]="def" [showInfoColumn]="false" [propColumnWidth]="'250px'">
        </app-config-editor-tree>
        <sm-form [form]="form"></sm-form>
        <p-button class="mt-3" icon="fas fa-cog" label="Erkennen" (onClick)="extractInformation()"></p-button>
    </p-panel>
    <p-tabView class="flex-item-fill height100p full-height direct-sub">
        <p-tabPanel header="Dokument">
            <ng2-pdfjs-viewer #viewer></ng2-pdfjs-viewer>
        </p-tabPanel>     
        <p-tabPanel header="Erkannter Text">
            <textarea pInputTextarea spellcheck=false class="height100p width100p monospace no-resize" [(ngModel)]="documentText"></textarea>
        </p-tabPanel>     
        <p-tabPanel header="Erkannter Text mit Layout">
            <textarea pInputTextarea spellcheck=false class="height100p width100p monospace no-resize" [(ngModel)]="documentTextWithLayout"></textarea>
        </p-tabPanel>     
        <p-tabPanel header="Erkannte Informationen Baum">
            <p-treeTable [value]="evaluationTree" class="flex-item-fill full-height">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Name</th>
                        <th>Value</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
                    <tr [ttRow]="rowNode" [ttContextMenuRow]="rowNode">
                        <td>
                            <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                            {{rowData.key}}
                        </td>
                        <td>{{rowData.value}}</td>
                    </tr>
                </ng-template>
            </p-treeTable>
        </p-tabPanel>
        <p-tabPanel header="Erkannte Informationen Text">
            <textarea pInputTextarea spellcheck=false class="height100p width100p monospace no-resize" [(ngModel)]="evaluationText"></textarea>
        </p-tabPanel>
        <p-tabPanel header="Ermitteltes JSON-Schema">
            <textarea pInputTextarea spellcheck=false class="height100p width100p monospace no-resize" [(ngModel)]="resultSchema"></textarea>
        </p-tabPanel>
        <p-tabPanel *ngIf="enaioForm != null" header="enaio Maske">
            <sm-form class="height100p width100p" [form]="enaioForm" [style.position]="'relative'">
            </sm-form> 
        </p-tabPanel>
    </p-tabView>
</div>